import gql from "graphql-tag";
import {useMemo} from "react";

import type {Result} from "@khanacademy/wonder-blocks-data";
import {useQuery} from "@khan/data-gql";
import {gqlOp, type GqlOperation} from "@khan/data-gql-core";

import type {Swag} from "../types.ts";

import type {aiGuideOwnedSwagQueryType} from "./__graphql-types__/index.ts";

export const AI_GUIDE_OWNED_SWAG_QUERY: GqlOperation<
    aiGuideOwnedSwagQueryType["response"],
    aiGuideOwnedSwagQueryType["variables"]
> = gqlOp(gql`
    query aiGuideOwnedSwagQuery {
        user {
            id
            aiGuideSwagOwned {
                id
                name
                altText
                description
                price
            }
        }
    }
`);

/**
 * Returns the result of the query which retrieves user-owned AI Guide
 * fashion items.
 */
export const useGuideOwnedClosetItems = (): [
    Result<Array<Swag>>,
    () => void,
] => {
    const [result, refetch] = useQuery(AI_GUIDE_OWNED_SWAG_QUERY);

    return useMemo(() => {
        if (result.status !== "success") {
            return [result, refetch];
        }

        return [
            {
                status: "success",
                data: result.data.user?.aiGuideSwagOwned ?? [],
            },
            refetch,
        ];
    }, [result, refetch]);
};
